import React, { useState, useRef } from "react";

const Side = () => {
  const [open, setOpen] = useState(false);
  const hoverTimer = useRef(null);

  const openPanel = () => {
    hoverTimer.current = setTimeout(() => setOpen(true), 200);
  };

  const closePanel = () => {
    clearTimeout(hoverTimer.current);
    setOpen(false);
  };

  return (
    <>
      {/* OVERLAY */}
      {open && <div className="side-overlay" onClick={closePanel} />}

      {/* FLOATING UNIT (BUTTON + PANEL MOVE TOGETHER) */}
      <div
        className={`side-unit ${open ? "open" : ""}`}
        onMouseLeave={closePanel}
      >
        {/* BUTTON */}
        <div className="side-btn" onMouseEnter={openPanel}>
          JOBS
        </div>

        {/* PANEL */}
        <div
          className="side-panel"
          onClick={() => (window.location.href = "/Career")}
        >
          <img
            src="/assets/images/side/hiring_side.png"
            alt="We are hiring"
          />
        </div>
      </div>
    </>
  );
};

export default Side;
